/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";

// react-router-dom components
import { Link, useHistory, useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiTypography from "components/SuiTypography";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import SuiEditor from "./SuiEditor";
import SuiButton from "components/SuiButton";

import { URL_SOURCEFILES } from "api/myslr";
import axios from "api/index";
import { useAuth } from "auth-context/auth.context";

// Soft UI Dashboard PRO React base styles
import borders from "assets/theme/base/borders";

// sweetalert2 components
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SuiDropzone from "./SuiDropzone";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SourceCard from "../SourceCard";

// sweetalert2 components
import Swal from "sweetalert2";

import { TailSpin } from "react-loader-spinner";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import scopusTutorial from "assets/tutorial/scopus_import.mp4";

// Images
import filePreview from "assets/pics/csv-file.png";

function ScopusBox({ querystring_id, reload, isQueryOwner }) {
  const { borderWidth, borderColor } = borders;
  const { user } = useAuth();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isHowtoOpened, setIsHowtoOpened] = useState(false);
  const [sourcefileData, setSourcefileData] = useState(null);
  const [fileData, setFileData] = useState({
    filename: "",
    filesize: 0,
  });
  const [newFileData, setNewFileData] = useState({
    sourcefile_querystring: querystring_id,
    sourcefile: null,
    sourcefile_db: "scopus",
    sourcefile_query_used: "",
    /*     sourcefile_total_papers: 0,
     */
  });
  const [error, setError] = useState(null);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleTutorialOpen = () => {
    setIsHowtoOpened(true);
  };

  const [importJob, setImportJob] = useState(null);
  const [importLogs, setImportLogs] = useState([]);
  const pollRef = useRef(null);
  const URL_IMPORTJOBS = "/v1/importjob";

  const LS_KEY = `importjob:scopus:${querystring_id}`;

  const lastError = [...importLogs]
    .reverse()
    .find((l) => l.level === "ERROR" && l.row_index !== null && l.row_index !== undefined);

  // Modal.setAppElement("body");
  Modal.setAppElement(document.getElementById("body"));

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const handleSave = () => {
    setIsLoading(true);
    setOpen(false);
    var formData = new FormData();
    let used_query = newFileData.sourcefile_query_used.replace(/&nbsp;/g, " ");
    formData.append("sourcefile", newFileData.sourcefile);
    formData.append("sourcefile_querystring", newFileData.sourcefile_querystring);
    formData.append("sourcefile_db", newFileData.sourcefile_db);
    if (newFileData.sourcefile_query_used !== "") {
      formData.append("sourcefile_query_used", used_query.replace(/(<([^>]+)>)/gi, ""));
    } else {
      formData.append("sourcefile_query_used", "None");
    }

    axios
      .post(URL_SOURCEFILES, formData, {
        headers: { Authorization: `${user.token}`, "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const jobId = response.data?.job_id;
        if (jobId) {
          startImportTracking(jobId);
        } else {
          // fallback: se per qualche motivo non arriva job_id
          handleFetch();
        }
        setIsLoading(false);
      })
      .catch((_error) => {
        setIsLoading(false);
        setError(_error);

        const msg =
          _error?.response?.data?.detail ||
          _error?.response?.data?.sourcefile?.[0] ||
          _error?.response?.data?.non_field_errors?.[0] ||
          _error?.message ||
          "Upload failed";

        Swal.fire("Import error", msg, "error");
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    const newSwal = Swal.mixin({
      customClass: {
        confirmButton: "button button-success",
        cancelButton: "button button-error",
      },
      buttonsStyling: false,
    });

    newSwal
      .fire({
        title: "Are you sure?",
        text: "Scopus dataset will be lost. You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          axios
            .delete(`${URL_SOURCEFILES}/${sourcefileData.id}`, {
              headers: { Authorization: `${user.token}` },
            })
            .then((response) => {
              if (response.status == 204) {
                handleFetch();
              } else {
                newSwal.fire("Error!", "We can't delete your sourcefile", "error");
              }
            })
            .catch((_error) => {
              setError(_error);
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          newSwal.fire("Cancelled", "File safe!", "error");
        }
      });
  };

  const handleFetch = () => {
    axios
      .get(`${URL_SOURCEFILES}?sourcefile_querystring=${querystring_id}&sourcefile_db=scopus`, {
        headers: { Authorization: `${user.token}` },
      })
      .then((response) => {
        setSourcefileData(response.data[0]);
        setIsLoading(false);
        reload();
      })
      .catch((_error) => {
        setError(_error);
      });
  };

  useEffect(() => {
    handleFetch();

    // se c’è un job attivo salvato, riprendi
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) {
        const { job_id } = JSON.parse(raw);
        if (job_id) {
          pollJob(job_id);
        }
      }
    } catch (e) {}

    return () => {
      // quando esci dalla pagina: stop polling (il job continua lato server)
      stopPolling();
    };
    // eslint-disable-next-line
  }, []);

  const stopPolling = () => {
    if (pollRef.current) {
      clearTimeout(pollRef.current);
      pollRef.current = null;
    }
  };

  const pollJob = (jobId) => {
    stopPolling();

    const headers = { Authorization: `${user.token}` };

    const tick = () => {
      Promise.all([
        axios.get(`${URL_IMPORTJOBS}/${jobId}`, { headers }),
        axios.get(`${URL_IMPORTJOBS}/${jobId}/logs?limit=200`, { headers }),
      ])
        .then(([jobRes, logsRes]) => {
          const job = jobRes.data;

          const logs = Array.isArray(logsRes.data) ? logsRes.data : logsRes.data?.results || [];
          const ordered = [...logs].reverse();

          console.log("LOGS len:", logs.length);
          console.log("LEVELS:", [...new Set(logs.map((l) => l.level))]);
          console.log(
            "ERROR logs:",
            logs
              .filter((l) => String(l.level).toUpperCase() === "ERROR")
              .map((l) => ({
                id: l.id,
                level: l.level,
                row_index: l.row_index,
                message: l.message,
              }))
          );

          setImportJob(job);
          setImportLogs(ordered);

          if (job.status === "done") {
            // finito: pulisci LS, stop, carica risultati
            localStorage.removeItem(LS_KEY);
            stopPolling();
            handleFetch();
            return;
          }

          if (job.status === "failed") {
            stopPolling();
            localStorage.removeItem(LS_KEY);

            const lastErr = [...ordered]
              .slice()
              .reverse()
              .find(
                (l) =>
                  String(l.level).toUpperCase() === "ERROR" &&
                  l.row_index !== null &&
                  l.row_index !== undefined
              );

            const msg = lastErr
              ? `Il file contiene un errore alla riga ${lastErr.row_index}. Correggi e ricarica.`
              : job.message || "Import fallito. Correggi il file e riprova.";

            Swal.fire("Import failed", msg, "error");

            // ✅ IMPORTANTISSIMO: per permettere nuovo upload, resetta DOPO aver mostrato msg
            setImportJob(null);
            setImportLogs([]);
            return;
          }

          pollRef.current = setTimeout(tick, 800);
        })
        .catch(() => {
          // se fallisce rete/temporaneo: riprova
          pollRef.current = setTimeout(tick, 1200);
        });
    };

    tick();
  };

  const startImportTracking = (jobId) => {
    // salva per ripresa dopo cambio pagina
    localStorage.setItem(LS_KEY, JSON.stringify({ job_id: jobId, ts: Date.now() }));
    setImportJob({
      id: jobId,
      status: "queued",
      progress_current: 0,
      progress_total: 0,
      message: "In attesa…",
    });
    setImportLogs([]);
    pollJob(jobId);
  };

  const handleQueryChange = (event) => {
    setNewFileData((prevState) => ({
      ...prevState,
      sourcefile_query_used: event,
    }));
  };

  const LiveReader = () => (
    <SuiBox
      mt={2}
      p={2}
      borderRadius="xl"
      boxShadow="xxl"
      sx={{ border: "1px solid #eee", width: "100%" }}
    >
      <SuiBox display="flex" justifyContent="space-between" alignItems="center">
        <SuiBox>
          <SuiTypography fontWeight="bold">Import process: {importJob?.status}</SuiTypography>
          <SuiTypography variant="caption">{importJob?.message || "…"}</SuiTypography>
        </SuiBox>

        <SuiTypography variant="caption" fontWeight="bold">
          {importJob?.progress_total
            ? `${importJob.progress_current}/${importJob.progress_total}`
            : "…"}
        </SuiTypography>
      </SuiBox>
      <div
        style={{
          marginTop: 10,
          height: 10,
          background: "#f4f4f4",
          borderRadius: 999,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: importJob?.progress_total
              ? `${Math.round((importJob.progress_current / importJob.progress_total) * 100)}%`
              : "0%",
            height: "100%",
            background: "#222",
          }}
        />
      </div>

      <div
        style={{
          marginTop: 12,
          maxHeight: 260,
          overflow: "auto",
          background: "#fafafa",
          borderRadius: 10,
          padding: 10,
        }}
      >
        {importLogs.length === 0 ? (
          <div style={{ fontSize: 13, opacity: 0.7 }}>Waiting for log...</div>
        ) : (
          importLogs.map((l) => (
            <div
              key={l.id}
              style={{ fontSize: 13, padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}
            >
              <b style={{ marginRight: 8 }}>{l.level}</b>
              {l.row_index ? (
                <span style={{ opacity: 0.7, marginRight: 8 }}>riga {l.row_index}</span>
              ) : null}
              <span>{l.message}</span>
            </div>
          ))
        )}
      </div>
      {/* <SuiBox mt={2} display="flex" justifyContent="flex-end" gap={1}>
        <SuiButton
          buttonColor="dark"
          size="small"
          onClick={() => {
            // nascondi solo UI, job continua e lo puoi riprendere tornando
            stopPolling();
            setImportJob(null);
            setImportLogs([]);
          }}
        >
          Hide
        </SuiButton>
        <SuiButton
          buttonColor="error"
          size="small"
          onClick={() => {
            // cancella tracking locale
            localStorage.removeItem(LS_KEY);
            stopPolling();
            setImportJob(null);
            setImportLogs([]);
          }}
        >
          Stop tracking
        </SuiButton>
      </SuiBox> */}
    </SuiBox>
  );

  const Uploader = () => (
    <SuiDropzone
      options={{
        addRemoveLinks: true,
        uploadMultiple: false,
        init: function () {
          this.on("addedfile", (file) => {
            setNewFileData((prevState) => ({
              ...prevState,
              sourcefile: file,
            }));
          });
          this.on("complete", (file) => {
            setFileData((prevState) => ({
              filename: file.name,
              filesize: (file.size / 1000000).toFixed(2),
            }));
          });
        },
      }}
    />
  );

  const Preview = () => (
    <SuiBox mt={2}>
      <SuiBox mb={1} lineHeight={0}>
        <SuiBox component="img" src={filePreview} alt="File preview" width={64} mb={3} />
        <SuiTypography component="label" variant="caption" fontWeight="bold">
          {fileData.filename}&nbsp;&nbsp;
          <SuiTypography variant="caption" fontWeight="regular" textColor="text">
            ({fileData.filesize} MB)
          </SuiTypography>
        </SuiTypography>
      </SuiBox>
    </SuiBox>
  );

  return (
    <SuiBox>
      <Grid container spacing={3} justifyContent="center" direction="column" alignItems="center">
        <Grid item xs={12} lg={12}>
          <Divider />
          {isLoading ? (
            <TailSpin />
          ) : importJob && (importJob.status === "queued" || importJob.status === "running") ? (
            <LiveReader />
          ) : sourcefileData ? (
            <Grid item xs={12} sm={12} lg={12}>
              <SourceCard data={sourcefileData} handleDelete={handleDelete} />
            </Grid>
          ) : isQueryOwner ? (
            <SuiBox
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              alignItems="center"
              borderRadius="xl"
              boxShadow="xxl"
              border={`${borderWidth[1]} dashed ${borderColor}`}
              textAlign="center"
              p={3}
            >
              <SuiTypography>Please import a csv file exported from Scopus </SuiTypography>

              <Grid item xs={12}>
                <div onClick={handleClickOpen}>
                  <SuiBox
                    backgroundColor="info"
                    borderRadius="50%"
                    width="3.625rem"
                    height="3.625rem"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    color="white"
                    mx="auto"
                    backgroundGradient
                    customClass="cursor-pointer"
                  >
                    <Icon className="" fontSize="small">
                      add
                    </Icon>
                  </SuiBox>
                </div>
                <div onClick={handleTutorialOpen}>
                  <SuiBox
                    width="100%"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    alignItems="left"
                    textAlign="left"
                    p={1}
                  >
                    <SuiButton buttonColor="success" size="small">
                      How to export a research file from Scopus
                    </SuiButton>
                  </SuiBox>
                </div>
                <Dialog open={open} onClose={handleClose} maxWidth={false}>
                  <DialogTitle>Import a new file</DialogTitle>
                  <DialogContent>
                    <SuiBox>
                      <SuiBox mt={3}>
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            File
                          </SuiTypography>
                        </SuiBox>
                        {newFileData.sourcefile ? (
                          <Preview />
                        ) : (
                          <SuiDropzone
                            options={{
                              addRemoveLinks: true,
                              uploadMultiple: false,
                              init: function () {
                                this.on("addedfile", (file) => {
                                  setNewFileData((prevState) => ({
                                    ...prevState,
                                    sourcefile: file,
                                  }));
                                });
                                this.on("complete", (file) => {
                                  setFileData((prevState) => ({
                                    filename: file.name,
                                    filesize: (file.size / 1000000).toFixed(2),
                                  }));
                                });
                              },
                            }}
                          />
                        )}
                      </SuiBox>
                      <SuiBox mt={2}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12}>
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography component="label" variant="caption" fontWeight="bold">
                                Used query&nbsp;&nbsp;
                                <SuiTypography
                                  variant="caption"
                                  fontWeight="regular"
                                  textColor="text"
                                >
                                  (optional)
                                </SuiTypography>
                              </SuiTypography>
                            </SuiBox>
                            <SuiEditor
                              value={newFileData.sourcefile_query_used}
                              placeholder="Insert used query..."
                              onChange={handleQueryChange}
                            />
                          </Grid>
                        </Grid>
                      </SuiBox>
                    </SuiBox>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </SuiBox>
          ) : (
            <SuiBox
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              alignItems="center"
              borderRadius="xl"
              boxShadow="xxl"
              border={`${borderWidth[1]} dashed ${borderColor}`}
              textAlign="center"
              p={3}
            >
              <SuiTypography>No files were uploaded for Web of Science</SuiTypography>
            </SuiBox>
          )}
        </Grid>
      </Grid>

      <Modal
        isOpen={isHowtoOpened}
        onRequestClose={() => setIsHowtoOpened(false)}
        style={customStyles}
      >
        <div>
          <ReactPlayer url={scopusTutorial} playing={true} controls={true} loop={true} />
        </div>
      </Modal>
    </SuiBox>
  );
}

export default ScopusBox;
